import store from '../../store'
import createAxios from './api'

const PATH = 'rssp/v1/server'
const PATH_RDSS = '/v1/server'

export default {
  async ping() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/ping`)

    return resp.data
  },

  async getCurrentTime() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/currentTime`)

    return resp.data
  },

  async getVersionInfo() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/version`)

    return resp.data
  },

  async getLicenseInfo() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/license`)

    return resp.data
  },

  async getRDSSVersionInfo() {
    const axios = await createAxios(false)
    const fullurl = store.state.remoteConfig.rdssApiUrl + PATH_RDSS + '/version'
    const resp = await axios.get(fullurl)

    return resp.data
  },

  async getMetrics() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/metrics`)

    return resp.data
  },

  async getOidcConfig(client) {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/oidcConfigs/${client}`)

    return resp.data
  },

  async getRemoteConfig() {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/config`)

    return resp.data
  },

  async getCountryList(langCode) {
    const axios = await createAxios(false)
    const resp = await axios.get(`${PATH}/countries/${langCode}`)

    return resp.data
  }
}
